import { MapContainer, TileLayer, Marker, useMapEvents } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import { useEffect, useState } from "react";
import markerIcon from "leaflet/dist/images/marker-icon.png";
import markerIcon2x from "leaflet/dist/images/marker-icon-2x.png";
import markerShadow from "leaflet/dist/images/marker-shadow.png";
import L from "leaflet";
const Map = ({ onLocationSelect, location }) => {
  const [position, setPosition] = useState(null);
  delete L.Icon.Default.prototype._getIconUrl;
  L.Icon.Default.mergeOptions({
    iconUrl: markerIcon,
    iconRetinaUrl: markerIcon2x,
    shadowUrl: markerShadow,
  });
  const [userLocation, setUserLocation] = useState(null);
  const riyadhCoords = [24.7136, 46.6753];

  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          setUserLocation([latitude, longitude]);
        },
        (error) => {
          alert(error.message);
          setUserLocation(riyadhCoords);
        }
      );
    } else {
      alert("Geolocation is not supported by this browser.");
      setUserLocation(riyadhCoords);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!userLocation) {
    return <div>Loading map...</div>;
  }
  const MapClickHandler = () => {
    useMapEvents({
      click(e) {
        const { lat, lng } = e.latlng;
        setPosition([lat, lng]);
        onLocationSelect({ lat, lng });
      },
    });
    return location ? (
      <Marker position={location} />
    ) : position ? (
      <Marker position={position} />
    ) : null;
  };
  return (
    <MapContainer
      center={location || userLocation}
      zoom={6}
      style={{ height: "200px", width: "100%" }}
    >
      <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
      <MapClickHandler />
    </MapContainer>
  );
};

export default Map;
